import { useState, useEffect, useContext } from 'react';
import { SocketContext } from '../../context/Socket/SocketContext';

export const useIdleStatusUpdates = () => {
  const [isConnected, setIsConnected] = useState(false);
  const [idleStatusUpdates, setIdleStatusUpdates] = useState({});
  const socketManager = useContext(SocketContext);

  // Conectar ao socket
  useEffect(() => {
    const companyId = localStorage.getItem('companyId');
    if (!companyId) return;

    const socket = socketManager.getSocket(companyId);

    const handleConnect = () => {
      setIsConnected(true);
      console.warn('Conectado ao socket para atualizações de ociosidade');
    };

    const handleDisconnect = () => {
      setIsConnected(false);
      console.warn('Desconectado do socket');
    };

    // Escutar atualizações de status de ociosidade
    const handleIdleStatusUpdate = data => {
      if (data.tickets) {
        const updates = {};
        data.tickets.forEach(ticket => {
          if (ticket.idleStatus) {
            updates[ticket.id] = ticket.idleStatus;
          }
        });
        setIdleStatusUpdates(prev => ({ ...prev, ...updates }));
      }
    };

    // Escutar atualizações individuais de ticket
    const handleTicketUpdate = data => {
      // Capturar atualizações de ociosidade em qualquer evento de ticket
      if (data.ticket?.idleStatus) {
        setIdleStatusUpdates(prev => ({
          ...prev,
          [data.ticket.id]: data.ticket.idleStatus,
        }));
      }
    };

    socket.on('connect', handleConnect);
    socket.on('disconnect', handleDisconnect);
    socket.on('ticket-idle-status-update', handleIdleStatusUpdate);
    socket.on(`company-${companyId}-ticket`, handleTicketUpdate);

    return () => {
      socket.off('connect', handleConnect);
      socket.off('disconnect', handleDisconnect);
      socket.off('ticket-idle-status-update', handleIdleStatusUpdate);
      socket.off(`company-${companyId}-ticket`, handleTicketUpdate);
    };
  }, [socketManager]);

  return {
    isConnected,
    idleStatusUpdates,
  };
};
